import { arrayRange } from "../../shared/utils";

const targetPositionCountMap = new Map([
  [0, "zero_position_count"],
  [1, "one_position_count"],
  [2, "two_position_count"],
  [3, "three_position_count"],
  [4, "four_position_count"],
  [5, "five_position_count"],
  [6, "six_position_count"],
]);

export function workflowResultDetails(args) {
  const { maxBehavioralQuestions } = args;

  return {
    get workflow() {
      return this.selectedWorkflow;
    },
    get compareTo() {
      return this.$store.snapshotResultFilters.compareTo;
    },
    percentageWidthForPosition(position) {
      return `width: ${this.workflowPercentageOfResponses(position)}`;
    },
    workflowPercentageOfResponses(position) {
      if (this.workflow["count"] === 0) return "0%";

      return `${Math.round(
        (100 * this.workflow[targetPositionCountMap.get(position)]) /
          this.workflow["count"],
      )}%`;
    },
    countForPosition(workflow, position) {
      if (!workflow) {
        // Workflow is null/undefined
        return 0;
      }

      if (!targetPositionCountMap.has(position)) {
        // Position not in map (invalid position)
        return 0;
      }

      const key = targetPositionCountMap.get(position);
      if (typeof key !== "string" || !key) {
        // Invalid key returned from map
        return 0;
      }

      return workflow[key] ?? 0;
    },
    targetedPositions() {
      if (this.workflow.target_direction == "u")
        return arrayRange(0, this.workflow.target_position, 1);

      return arrayRange(
        this.workflow.target_position,
        maxBehavioralQuestions - 1,
        1,
      ).reverse();
    },
    nonTargetedPositions() {
      if (this.workflow.target_direction == "u")
        return arrayRange(
          this.workflow.target_position + 1,
          maxBehavioralQuestions - 1,
          1,
        );

      return arrayRange(0, this.workflow.target_position - 1, 1).reverse();
    },
    calculateWorkflowComparison() {
      if (this.compareTo == "vs_50th") {
        return this.workflow.avg_value_diff_50 ?? null;
      } else if (this.compareTo == "vs_75th") {
        return this.workflow.avg_value_diff_75 ?? null;
      } else if (this.compareTo == "vs_90th") {
        return this.workflow.avg_value_diff_90 ?? null;
      } else if (this.compareTo == "vs_prev") {
        return this.workflow.avg_value_diff_prev ?? null;
      } else if (this.compareTo == "vs_org") {
        return this.workflow.avg_value_diff_org ?? null;
      }
    },
  };
}
